const addSlug = (slug) => (query) => (query ? `/${slug}${query}` : `/${slug}`);

export default addSlug;



// WEBPACK FOOTER //
// ./src/utils/queries/add-slug.js